import { useState } from 'react';
import { profilePhotos } from '@/mocks/profile';

export default function PhotoCarousel() {
  const [index, setIndex] = useState(0);
  const [preview, setPreview] = useState(false);
  const [touchStart, setTouchStart] = useState<number | null>(null);

  const total = profilePhotos.length;
  const current = profilePhotos[index];

  const go = (dir: number) => setIndex((i) => (i + dir + total) % total);

  const handleTouchStart = (e: React.TouchEvent) => setTouchStart(e.touches[0].clientX);
  const handleTouchEnd = (e: React.TouchEvent) => {
    if (touchStart === null) return;
    const diff = e.changedTouches[0].clientX - touchStart;
    if (diff > 50) go(-1);
    if (diff < -50) go(1);
    setTouchStart(null);
  };

  return (
    <div>
      <div
        className="relative w-full aspect-[4/3] md:aspect-[16/10] rounded-lg overflow-hidden border border-background-200 bg-background-100"
        onTouchStart={handleTouchStart}
        onTouchEnd={handleTouchEnd}
      >
        <img
          src={current.src}
          alt={current.caption}
          title={`小仓优子 ${current.caption}`}
          className="w-full h-full object-cover object-top cursor-zoom-in"
          onClick={() => setPreview(true)}
        />
        <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-foreground-950/60 to-transparent px-5 py-4">
          <span className="text-sm text-background-50">{current.caption}</span>
          <span className="text-xs text-background-100/80 ml-3">
            {index + 1} / {total}
          </span>
        </div>

        <button
          type="button"
          aria-label="上一张"
          onClick={() => go(-1)}
          className="absolute left-3 top-1/2 -translate-y-1/2 w-9 h-9 rounded-full bg-background-50/85 text-foreground-800 flex items-center justify-center hover:bg-background-50 transition-colors cursor-pointer"
        >
          <i className="ri-arrow-left-s-line text-xl"></i>
        </button>
        <button
          type="button"
          aria-label="下一张"
          onClick={() => go(1)}
          className="absolute right-3 top-1/2 -translate-y-1/2 w-9 h-9 rounded-full bg-background-50/85 text-foreground-800 flex items-center justify-center hover:bg-background-50 transition-colors cursor-pointer"
        >
          <i className="ri-arrow-right-s-line text-xl"></i>
        </button>
      </div>

      <div className="flex items-center gap-3 mt-4 overflow-x-auto pb-1">
        {profilePhotos.map((photo, i) => (
          <button
            key={photo.src}
            type="button"
            onClick={() => setIndex(i)}
            aria-label={`查看第 ${i + 1} 张`}
            className={`w-20 h-14 flex-shrink-0 rounded-md overflow-hidden border-2 transition-colors cursor-pointer ${
              i === index ? 'border-accent-500' : 'border-transparent opacity-70 hover:opacity-100'
            }`}
          >
            <img src={photo.src} alt={photo.caption} title={photo.caption} className="w-full h-full object-cover object-top" />
          </button>
        ))}
      </div>

      {preview && (
        <div
          className="fixed inset-0 z-[60] bg-foreground-950/80 flex items-center justify-center p-4"
          onClick={() => setPreview(false)}
        >
          <button
            type="button"
            aria-label="关闭预览"
            className="absolute top-5 right-5 w-10 h-10 rounded-full bg-background-50/90 text-foreground-800 flex items-center justify-center cursor-pointer"
            onClick={() => setPreview(false)}
          >
            <i className="ri-close-line text-xl"></i>
          </button>
          <img
            src={current.src}
            alt={current.caption}
            title={`小仓优子 ${current.caption}`}
            className="max-w-full max-h-[85vh] rounded-lg object-contain"
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}
    </div>
  );
}